<div *ngIf="eixo == 'horizontal'">
  <ul class="horizontal">

    <li [attr.data-cy]="returnDataCy(eixo, 'Consórcio')" [showIfPermission]="consortiumPermission"
      (click)="buildConsortiumTree()">
      <a class="estricta uppercase bolder" [matMenuTriggerFor]="menuConsortium"> Consórcio </a>
    </li>
    <li [attr.data-cy]="returnDataCy(eixo, 'Banco')" [showIfPermission]="bankPermission">
      <a class="estricta uppercase bolder" [matMenuTriggerFor]="menuBank"> Banco </a>
    </li>
    <li [attr.data-cy]="returnDataCy(eixo, 'Seguros')" [showIfPermission]="insurancePermission">
      <a class="estricta uppercase bolder" [matMenuTriggerFor]="menuInsurance"> Seguros </a>
    </li>

    <li [attr.data-cy]="returnDataCy(eixo, 'Configurações')" [showIfPermission]="settingsPermission">
      <a class="estricta uppercase bolder" [matMenuTriggerFor]="menuSettings"> Configurações </a>
    </li>

    <li [attr.data-cy]="returnDataCy(eixo, 'Relatórios')" [showIfPermission]="reportsPermission">
      <a class="estricta uppercase bolder" [matMenuTriggerFor]="menuReports"> Relatórios </a>
    </li>

    <ng-container *ngFor="let route of routesMenu()">
      <li [attr.data-cy]="returnDataCy(eixo, route.name)">
        <a class="estricta uppercase bolder" *ngIf="!route.path.startsWith('http') else externalLinkHorizontal"
          [showIfPermission]="route.permissions" [routerLink]="route.path" (click)="closeMenu()"> {{route.name}} </a>

        <ng-template #externalLinkHorizontal>
          <a class="estricta uppercase bolder" [showIfPermission]="route.permissions" target="_blank"
            [href]="route.path" (click)="closeMenu()"> {{route.name}} </a>
        </ng-template>
      </li>
    </ng-container>
  </ul>

  <input mat-menu-item cdkFocusInitial type='text' class="hidden" />

  <mat-menu #menuSettings="matMenu">
    <input mat-menu-item cdkFocusInitial type='text' class="hidden" />

    <button mat-menu-item *ngFor="let route of routesMenuSettings" [showIfPermission]="route.permissions"
      [routerLink]="route.path">
      <a class="estricta uppercase bolder" [showIfPermission]="route.permissions">{{route.name}}</a>
    </button>
  </mat-menu>

  <mat-menu #menuReports="matMenu">
    <input mat-menu-item cdkFocusInitial type='text' class="hidden" />

    <button mat-menu-item *ngFor="let route of routesMenuReports" [showIfPermission]="route.permissions"
      [routerLink]="route.path">
      <a class="estricta uppercase bolder" [showIfPermission]="route.permissions">{{route.name}}</a>
    </button>
  </mat-menu>


  <mat-menu #menuConsortium="matMenu">
    <app-sub-menu [dataSource]="dataSourceConsortium" (emitCloseMenu)="closeMenuConsortium(menuConsortium)"></app-sub-menu>
  </mat-menu>

  <mat-menu #menuBank="matMenu">
    <input mat-menu-item cdkFocusInitial type='text' class="hidden" />

    <button mat-menu-item *ngFor="let route of routesMenuBank" [showIfPermission]="route.permissions"
      [routerLink]="route.path">
      <a class="estricta uppercase bolder" [showIfPermission]="route.permissions">{{route.name}}</a>
    </button>
  </mat-menu>
  <mat-menu #menuInsurance="matMenu">
    <input mat-menu-item cdkFocusInitial type='text' class="hidden" />

    <button mat-menu-item *ngFor="let route of routesMenuInsurance" [showIfPermission]="route.permissions"
      [routerLink]="route.path">
      <a class="estricta uppercase bolder" [showIfPermission]="route.permissions">{{route.name}}</a>
    </button>
  </mat-menu>


</div>

<div *ngIf="eixo == 'vertical'" class="vertical-menu-wrapper">
  <app-vertical  [dataSource]="dataSourceMenu" (emitCloseMenu)="closeMenu()"></app-vertical>
  <div class="avatar-wrapper">
    <app-avatar/>
  </div>
</div>
